import { SELECT_ALL_SCENARIO_GROUP_INFO } from "../../../constants/closeLoop/scenarioGroup/closeLoopScenarioGroupConstants";

const defaultselectAllScenarioGroupInfo = {
    totalGroup: 0,
    totalGroupList: [],
};

export const selectAllScenarioGroupInfoReducer = (
    state = defaultselectAllScenarioGroupInfo,
    action
) => {
    switch (action.type) {
        case SELECT_ALL_SCENARIO_GROUP_INFO:
            return {
                totalGroup: action.totalGroup,
                totalGroupList: action.totalGroupList,
            };
        default:
            return state;
    }
};
